import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { EncryptYamatoBaggageResultEffect } from './encrypt-yamato-baggage-result.effect';
import { encryptYamatoBaggageResultReducer } from './encrypt-yamato-baggage-result.reducer';
import {
  ENCRYPT_YAMATO_BAGGAGE_RESULT_STORE_NAME,
  EncryptYamatoBaggageResultState,
} from './encrypt-yamato-baggage-result.state';

/** Token of the EncryptYamatoBaggageResult reducer */
export const ENCRYPT_YAMATO_BAGGAGE_RESULT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<EncryptYamatoBaggageResultState, Action>
>('Feature EncryptYamatoBaggageResult Reducer');

/** Provide default reducer for EncryptYamatoBaggageResult store */
export function getDefaultEncryptYamatoBaggageResultReducer() {
  return encryptYamatoBaggageResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(ENCRYPT_YAMATO_BAGGAGE_RESULT_STORE_NAME, ENCRYPT_YAMATO_BAGGAGE_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([EncryptYamatoBaggageResultEffect]),
  ],
  providers: [
    { provide: ENCRYPT_YAMATO_BAGGAGE_RESULT_REDUCER_TOKEN, useFactory: getDefaultEncryptYamatoBaggageResultReducer },
  ],
})
export class EncryptYamatoBaggageResultStoreModule {
  public static forRoot<T extends EncryptYamatoBaggageResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<EncryptYamatoBaggageResultStoreModule> {
    return {
      ngModule: EncryptYamatoBaggageResultStoreModule,
      providers: [{ provide: ENCRYPT_YAMATO_BAGGAGE_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
